import classes from "../ServicesTable.module.scss"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useContext, useEffect, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { servicesEditFields } from "./servicesColumns";
import Button from "../../UI/Button";
import ServiceForm from "./ServiceForm";
import { OrgIdContext } from "../../../store/orgId_context";
import EditOffIcon from '@mui/icons-material/EditOff';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CircleIcon from '@mui/icons-material/Circle';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { t } from "i18next";

const ServicesTableTr = ({data:inputData, index, tableInfo, orgData, onSubmit, master, refetch}) => {
    const [editable, setEditable] = useState();
    const [hasFields, setHasFields] = useState(false);
    const [data, setData] = useState({})
    const { isMaintainer } = useContext(OrgIdContext);

    const [showForm, setShowForm] = useState(false);

    const onTrClick = () =>{
        /*if(!editable)
            return;*/
        if(!hasFields)
            return;
        setShowForm(prev => !prev);
    }

//#region field helpers
    const getFieldKey = (fieldName) => {
        if(data.hasOwnProperty(fieldName))
            return fieldName;

        return getFullFieldKey(fieldName);
    }
    const getFullFieldKey = (fieldName) => {
        let field = servicesEditFields.filter(obj => obj.name === fieldName)[0];
        let append = "";
        if(field && field.groupFields){
            field.groupFields.forEach(val => append = append+val+"__")

        }
        return append+fieldName;
    }
    const getHardcodedFieldInfo = (fieldName) =>{
        return servicesEditFields.filter(obj => obj.name === fieldName)[0];
    }
    const getFieldValue = (fieldName) => {
        if(data.hasOwnProperty(fieldName))
            return data[fieldName];
        if(data.hasOwnProperty(getFullFieldKey(fieldName)))
            return data[getFullFieldKey(fieldName)]
        return null;
    }

//#endregion
    const getIconForDirection = (direction) =>{
        switch(direction){
            case "Recieve":
                return <MoveToInboxIcon className="main-blue"/>
            case "Send":
                return <OutboxIcon className="main-blue"/>
            case "Both":
                return <ImportExportIcon className="main-blue"/>
            case "PushREI":
                return <LoginIcon className="main-blue" style={{transform:"rotate(-90deg)"}}/>
            case "PushIEI":
                return <StartIcon className="main-blue" style={{transform:"rotate(-90deg)"}}/>
            case "Push":
                return <CloudUploadIcon className="main-blue"/>
            default:
                return <OutboxIcon className="main-blue"/>
        }
    }
    const getIconForType = (type) =>{
        switch(type){
            case "PublicSector":
                return <PublicIcon className="main-blue"/>
            case "PrivateSector":
                return <PublicOffIcon className="main-blue"/>
            case "All":
                return <AllInclusiveIcon className="main-blue"/>
            default:
                return <AllInclusiveIcon className="main-blue"/>
        }
    }

    useEffect(() => {
        if(!inputData)
            return setEditable(false);

        if(isMaintainer){
            
            if(getRulesFields().length > 0)
                setHasFields(true);
        }else{
            console.log(getUserFields().length);
            if(getUserFields().length > 0)
                setHasFields(true);
        }
        
        if(inputData["ServiceEndPointCode__NonCustomerEditable"])
            return setEditable(false);
        if(inputData["NonCustomerEditable"])
            return setEditable(false);
        if(isMaintainer && inputData.ServiceEndPointCode__MaintainerUIRules && inputData.ServiceEndPointCode__MaintainerUIRules.length > 0)
            return setEditable(true);
        if(inputData.ServiceEndPointCode__UserUIRules && inputData.ServiceEndPointCode__UserUIRules.length>0)
            return setEditable(true);
        setEditable(false);
    }, [inputData]);
    
    useEffect(()=>{
        if(inputData){
            setData(inputData);
        }
    }, [inputData])

    const onFormSubmit = (data, res) =>{
        if(!editable || master) return console.warn("Not editable");
        if(onSubmit)
            onSubmit(data, res);
    }

    const getUserFields = () =>{
        let fields = [];
        const uirules = inputData.ServiceEndPointCode__UserUIRules || inputData.UserUIRules || false;
        if(uirules) fields = getRulesAsArray(uirules);
        return fields;
    }
    const getRulesFields = () =>{
        let fields = [];
        const uirules = inputData.ServiceEndPointCode__UserUIRules || inputData.UserUIRules || false;
        const mrules = inputData.ServiceEndPointCode__MaintainerUIRules || inputData.MaintainerUIRules || false;

        if(uirules) fields = getRulesAsArray(uirules);
        if(isMaintainer && mrules){
             let mfields = getRulesAsArray(mrules);
             mfields.forEach(item => fields.includes(item) ? null : fields.push(item));
        }

        return fields;
    }

    const getRulesAsArray = (str) => {
        const ret = [];
        if(!str) return ret;
        str = str.replace(/[\[\] *]/g, "");
        if(!str || str.length === 0) return ret;
        return str.split(",");
    }
    
    return (
    <>
        <Container className={`${classes["rowContainer"]} g-0`} style={index%2===0 ? {backgroundColor:"#f1f5fd"} : {backgroundColor:"#f9fbff"}}>
            <Row  className={`${classes["tableRow"]} g-0`} onClick={onTrClick} style={hasFields ? {cursor:"pointer"} : {}}>
                <Col className={`col-1 ${classes["trcol"]}`}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{data["ServiceEndPointCode__Step__StepDescription"]}</Tooltip>}>
                        <i className={classes["stepCircle"]}>{data["ServiceEndPointCode__Step"]}</i>
                    </OverlayTrigger>
                </Col> 
                <Col className={`col-5 ${classes["trcol"]}`} style={{textAlign:"left", paddingLeft:"1rem", fontWeight:"bold"}}>{getFieldValue("Description") || getFieldValue("ServiceEndPointCode")}</Col>
                <Col className={`col-2 ${classes["trcol"]}`} style={{textAlign:"left", paddingLeft:"1rem"}}>{data["ServiceEndPointCode"]}</Col>
                <Col className={`col-2 ${classes["trcol"]}`}>{data["ServiceEndPointCode__Purpose"]}</Col>
                {/* <Col className={`col-1 ${classes["trcol"]}`} style={{color:"#005683"}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{getFieldValue("Direction")}</Tooltip>}>
                        {getIconForDirection(getFieldValue("Direction"))}
                    </OverlayTrigger>
                </Col> */}
                {/* <Col className={`col-1 ${classes["trcol"]}`}>
                    {data["Valid"] === true && <CheckCircleIcon style={{color:"green"}}/>}
                    {data["Valid"] !==true && <UnpublishedIcon style={{color:"#005683"}}/>}
                </Col> */}
                {/* <Col className={`col-1 ${classes["trcol"]}`} style={{color:"#005683"}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{data["ServiceEndPointCode__Type"]}</Tooltip>}>
                        {getIconForType(getFieldValue("Type"))}
                    </OverlayTrigger>
                </Col> */}
                {/* <Col className={`col-1 ${classes["trcol"]}`} style={{color:"#005683"}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{data["Activated"] === true ? "Activated" : "Not active"}</Tooltip>}>
                        <CircleIcon  className={data["Activated"]===true ? "main-green" : "main-blue"}/>
                    </OverlayTrigger>
                </Col> */}
                <Col className={`col-2 ${classes["trcollast"]}`} style={{textAlign:"right", paddingRight:"1rem"}}>
                    {/* {!editable && <EditOffIcon style={{fontSize:"1rem"}}/>} */}
                    
                    {hasFields && editable && !showForm && <><KeyboardArrowLeftIcon className="main-green" style={{fontSize:"1rem"}}/> <ModeEditIcon className={`main-green ${classes["editIcon"]}`} style={{fontSize:"1rem"}}/></>}
                    {hasFields && editable && showForm && <KeyboardArrowDownIcon className="main-green" style={{fontSize:"1.3rem"}}/>}
                    {hasFields && !editable && !showForm && <><KeyboardArrowLeftIcon className="main-green" style={{fontSize:"1rem"}}/> <VisibilityIcon className={`main-green ${classes["editIcon"]}`} style={{fontSize:"1rem"}}/></>}
                    {hasFields && !editable && showForm && <KeyboardArrowDownIcon className="main-green" style={{fontSize:"1.3rem"}}/>}
                    {!hasFields && 
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Nothing to view or edit")}</Tooltip>}>
                            <ContactSupportIcon className="main-blue"/>
                        </OverlayTrigger>
                        
                    }
                </Col>
            </Row>
            {showForm &&
            <Row className={classes["formRow"]}>
                <Col>
                    <ServiceForm data={data} info={tableInfo} onSubmit={onFormSubmit} editable={editable} orgData={orgData} refetch={refetch}/>
                </Col>
            </Row>
            }
        </Container>
    </>
    )
}

export default ServicesTableTr;